import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';
import { AccountsEditorState } from '../store/schema/AccountsEditorState';

/**
 * Sets the edit state account is in
 */
export default mutatorAction('setAccountsEditorState', function (
    accountsEditorState: AccountsEditorState
) {
    getStore().accountsEditorState = accountsEditorState;
});
